"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _dayjs = _interopRequireDefault(require("dayjs"));

require("./styles.css");

var _DateInputGroup = _interopRequireDefault(require("./DateInputGroup"));

var _Dialog = _interopRequireDefault(require("./Dialog"));

var _DialogWrapper = _interopRequireDefault(require("./DialogWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SingleDatePicker = function SingleDatePicker(_ref) {
  var startDate = _ref.startDate,
      startDatePlaceholder = _ref.startDatePlaceholder,
      className = _ref.className,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      startWeekDay = _ref.startWeekDay,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      dateFormat = _ref.dateFormat,
      monthFormat = _ref.monthFormat,
      highlightToday = _ref.highlightToday,
      isOpen = _ref.isOpen,
      onCloseCalendar = _ref.onCloseCalendar,
      singleCalendar = _ref.singleCalendar,
      weekDayFormat = _ref.weekDayFormat,
      ignoreDefaultControls = _ref.ignoreDefaultControls;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      complsOpen = _useState2[0],
      setComplsOpen = _useState2[1];

  var containerRef = (0, _react.useRef)(null);

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      fromDate = _useState4[0],
      setFromDate = _useState4[1];

  var fromDateRef = (0, _react.useRef)();

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      hoverDate = _useState6[0],
      setHoverDate = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isMobile = _useState8[0],
      setIsMobile = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isCancel = _useState10[0],
      setIsCancel = _useState10[1];

  function handleResize() {
    if (typeof window !== 'undefined' && window.innerWidth < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }

  (0, _react.useLayoutEffect)(function () {
    handleResize();

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
      return function () {
        return window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  function notifyChange() {
    var _startDate = fromDateRef.current ? fromDateRef.current.toDate() : null;

    onChange(_startDate);
  }

  function updateFromDate(dateValue) {
    setFromDate(dateValue);
    fromDateRef.current = dateValue;
  }

  (0, _react.useEffect)(function () {
    setComplsOpen(isOpen);

    if (startDate) {
      updateFromDate((0, _dayjs.default)(startDate), false);
    }
  }, [isCancel]);
  (0, _react.useEffect)(function () {
    var _startDateJs = startDate ? (0, _dayjs.default)(startDate) : null;

    fromDateRef.current = _startDateJs;
    setFromDate(_startDateJs);
  }, [startDate]);
  (0, _react.useEffect)(function () {
    if (!complsOpen) {
      onCloseCalendar();
      notifyChange();
    }
  }, [complsOpen]);
  (0, _react.useEffect)(function () {
    setComplsOpen(isOpen);
  }, [isOpen]);

  function toggleDialog() {
    setComplsOpen(!complsOpen);
  }

  function handleClickDateInput() {
    if (disabled) return;

    if (!complsOpen) {
      setComplsOpen(true);
    }

    onFocus('Start Date');
  }

  function onSelectDate(date) {
    if (minDate && (0, _dayjs.default)(minDate).isAfter(date, 'date') || maxDate && (0, _dayjs.default)(maxDate).isBefore(date, 'date')) {
      return;
    }

    updateFromDate(date, true);
  }

  function onHoverDate(date) {
    setHoverDate(date);
  }

  function handleReset() {
    updateFromDate(null, true);
    setHoverDate(null);
  }

  function onDateInputFocus() {
    handleClickDateInput();
  }

  function onCancel() {
    setIsCancel(!isCancel);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "react-google-flight-datepicker"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('date-picker', className, {
      disabled: disabled
    }),
    ref: containerRef
  }, !ignoreDefaultControls && /*#__PURE__*/_react.default.createElement(_DateInputGroup.default, {
    handleClickDateInput: handleClickDateInput,
    showCalendarIcon: true,
    fromDate: fromDate,
    minDate: minDate,
    maxDate: maxDate,
    handleChangeDate: onSelectDate,
    startDatePlaceholder: startDatePlaceholder,
    dateFormat: dateFormat,
    onFocus: onDateInputFocus,
    isSingle: true
  }), /*#__PURE__*/_react.default.createElement(_DialogWrapper.default, {
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    complsOpen: complsOpen,
    setComplsOpen: setComplsOpen,
    toggleDialog: toggleDialog,
    handleClickDateInput: handleClickDateInput,
    inputFocus: "from",
    onSelectDate: onSelectDate,
    onHoverDate: onHoverDate,
    fromDate: fromDate,
    hoverDate: hoverDate,
    handleReset: handleReset,
    handleChangeDate: onSelectDate,
    startDatePlaceholder: startDatePlaceholder,
    startWeekDay: startWeekDay,
    minDate: minDate,
    maxDate: maxDate,
    dateFormat: dateFormat,
    monthFormat: monthFormat,
    isMobile: isMobile,
    highlightToday: highlightToday,
    isSingle: true,
    weekDayFormat: weekDayFormat,
    singleCalendar: singleCalendar,
    onCancel: onCancel
  }))));
};

SingleDatePicker.propTypes = {
  startDate: _propTypes.default.instanceOf(Date),
  startDatePlaceholder: _propTypes.default.string,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  startWeekDay: _propTypes.default.oneOf(['monday', 'sunday']),
  minDate: _propTypes.default.instanceOf(Date),
  maxDate: _propTypes.default.instanceOf(Date),
  dateFormat: _propTypes.default.string,
  monthFormat: _propTypes.default.string,
  weekDayFormat: _propTypes.default.string,
  highlightToday: _propTypes.default.bool,
  isOpen: _propTypes.default.bool,
  onCloseCalendar: _propTypes.default.func,
  singleCalendar: _propTypes.default.bool,
  ignoreDefaultControls: _propTypes.default.bool
};
SingleDatePicker.defaultProps = {
  startDate: null,
  className: '',
  disabled: false,
  startDatePlaceholder: 'Date',
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  startWeekDay: 'monday',
  weekDayFormat: 'dd',
  minDate: null,
  maxDate: null,
  dateFormat: '',
  monthFormat: '',
  highlightToday: false,
  isOpen: false,
  onCloseCalendar: function onCloseCalendar() {},
  ignoreDefaultControls: false
};
var _default = SingleDatePicker;
exports.default = _default;